import React from 'react';
import ReactDOM from 'react-dom';
import domready from 'domready';
import HeroCarousel from './components/HeroCarousel';
import brandsSearchBar from './components/BrandsSearchBar/index.js';
import textAppForm from 'shared-components/TextAppForm';
import YoutubePlayer from 'shared-components/YoutubePlayer';

// Leave commented out for easy static markup creation
// import { renderToStaticMarkup } from 'react-dom/server';
// import BrandsSearchBar from './components/BrandsSearchBar/BrandsSearchBar';
// import TextAppForm from 'shared-components/TextAppForm/component';

const slides = window.Raise.data.homepage.carousel;
const { placeholder, headline, videoId } = window.Raise.data.homepage.guarantee;

domready(() => {
  const $carouselEl = document.getElementById('react-hero-carousel');
  const carousel = <HeroCarousel slides={slides} />;
  const $searchBarEl = document.getElementById('react-search-bar');
  const $textAppFormEl = document.getElementById('text-app-form');
  const $guaranteeVideoEl = document.getElementById('guarantee-video-container');
  const video = <YoutubePlayer videoId={ videoId } placeholder={ placeholder } headline={ headline } />;

  if ($carouselEl) ReactDOM.render(carousel, $carouselEl);
  if ($searchBarEl) brandsSearchBar.standalone($searchBarEl);
  if ($textAppFormEl) textAppForm.standalone($textAppFormEl);
  if ($guaranteeVideoEl) ReactDOM.render(video, $guaranteeVideoEl);

  // Leave commented out for easy static markup creation
  // console.warn('HeroCarousel');
  // slides.forEach((slide) => slide.url = 'https://dnrzlv4wd9rbi.cloudfront.net/assets/new_homepage/buyGiftCards.jpg');
  // console.log(renderToStaticMarkup(carousel));
  // console.warn('BrandsSearchBar');
  // console.log(brandsSearchBar.renderStaticMarkup());
  // console.warn('TextAppForm');
  // console.log(textAppForm.renderStaticMarkup());
  // console.warn('Video');
  // console.log(renderToStaticMarkup(video));
  //
});



/** WEBPACK FOOTER **
 ** ./apps/homepage/index.js
 **/